import {SeasonDto} from "dto/season-dto";
import {BaseCrudService} from "./baseCrudService";

class SeasonService extends BaseCrudService<SeasonDto> {
  constructor() {
    super("/api/v1/seasons");
  }
}

export const seasonService = new SeasonService();
